import { createFileRoute } from "@tanstack/react-router"
import { TenantBillingSection } from "#/components/admin/tenant-billing-section"
import { RouteError } from "#/components/route-error"
import { Skeleton } from "#/components/ui/skeleton"
import { useIsPlatformOperator } from "#/hooks/useIsTenantAdmin"

export const Route = createFileRoute("/_authenticated/admin/tenants/$orgId/billing")({
	errorComponent: RouteError,
	component: BillingTab,
})

function BillingTab() {
	const { orgId } = Route.useParams()
	const { isOperator, isLoading } = useIsPlatformOperator()

	if (isLoading) return <Skeleton className="h-48 w-full" />
	if (!isOperator) {
		return (
			<div className="py-12 text-center text-sm text-foreground-muted">
				This tab is for platform operators.
			</div>
		)
	}
	return <TenantBillingSection orgId={orgId} />
}
